<img class="{{class}}" src="{{src}}"  [alt]="alt ?? ''" />
